<template>
    <div class="widget-container">
        <iframe v-if="data.index_html"
            :src="iframeSrc"
            :style="elementStyle"
            class="widget-iframe"
            sandbox="allow-scripts allow-same-origin"
            scrolling="no" />
        <img v-else
             class="widget-background-image"
             :src="data.background_image"
             alt="Widget Thumbnail">
    </div>
</template>

<script>

export default {
    props: {
        /** @type {PublishElementDataCommon | PublishElementDataWidget} */
        data: Object,
        /** @type {number | null} - Computed sizeRatio or null if height property was not available */
        sizeRatio: Number,
        height: Number,
        width: Number
    },
    computed: {
        iframeSrc() {
            return this.data.index_html ? `${this.data.index_html}${this.data.query_string || ''}` : '';
        },
        /** @returns {Partial<CSSStyleDeclaration>}*/
        elementStyle() {
            return {
                height: `${this.height}px`,
                width: `${this.width}px`,
                transform: `scale(${this.sizeRatio})`
            }
        }
    }
}
</script>

<style>
.widget-container {
    width: 100%;
    height: 100%;
}

.widget-container .widget-iframe {
    transition: transform var(--thumbnail-transition-dimensions-duration) ease-out;
    transform-origin: 0 0;
    overflow: hidden;
    overflow: clip;
    pointer-events: none;
}

.widget-container .widget-background-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
    text-align: center;
}
</style>
